import { faCube, faSquare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import type { Dispatch, ReactNode, SetStateAction } from "react";
import type { PanelVisuProps } from ".";

export type CanvasSettingType = {
	view: PanelVisuProps["view"];
	field: PanelVisuProps["currentField"];
};

interface CanvasSettingsProps {
	canvasSettings: CanvasSettingType;
	setCanvasSettings: Dispatch<SetStateAction<CanvasSettingType>>;
}

export function CanvasSettings(props: CanvasSettingsProps) {
	return (
		<div className="absolute right-0 bottom-0 flex gap-1.5 rounded-tl bg-shades-light p-1.5 sm:gap-2 sm:p-2">
			<SettingButton current="2d" {...props}>
				<FontAwesomeIcon icon={faSquare} className="hidden sm:inline" />
				<span>2D</span>
			</SettingButton>
			<SettingButton current="3d" {...props}>
				<FontAwesomeIcon icon={faCube} className="hidden sm:inline" />
				<span>3D</span>
			</SettingButton>
		</div>
	);
}

interface SettingButtonProps extends CanvasSettingsProps {
	current: PanelVisuProps["view"];
	children: ReactNode;
}

function SettingButton(props: SettingButtonProps) {
	const { canvasSettings, setCanvasSettings, current, children } = props;

	const isDetail = canvasSettings.view === "detail" && current === "2d";

	return (
		<button
			type="button"
			onClick={() => setCanvasSettings({ field: undefined, view: current })}
			className={cn(
				"flex items-center gap-1 rounded px-1 py-0.5 text-xs focus:outline-none motion-safe:transition-colors sm:px-2 sm:py-1 sm:text-sm",
				{
					"bg-primary-medium enter:bg-primary-dark text-white":
						canvasSettings.view === current || isDetail,
					"bg-white enter:bg-shades-medium-light": canvasSettings.view !== current && !isDetail,
				},
			)}
		>
			{children}
		</button>
	);
}
